import React from "react";
import { Alert as AlertAntd, Col, Row, Typography } from "antd";
import { JoinedAlert } from "../../../types";
import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";
import { CheckCircleIcon } from "@heroicons/react/24/solid";
import { formatDate } from "../../../utils/helpers";

const { Text } = Typography;

type Props = {
  item: JoinedAlert;
};

const AlertDialog: React.FC<Props> = ({ item }) => {
  const message = item.message;

  const dateString = formatDate(
    item?.context?.data?.timestamp || item?.created_at,
  );

  return (
    <div key={item?._id} className="alert-dialog-container">
      <AlertAntd
        message={
          <Row
            style={{
              display: "flex",
              alignItems: "flex-start",
              justifyContent: "space-between",
            }}
          >
            <Col style={{ flex: 1, minWidth: 0 }}>
              <Row>
                <Text className="font-bold">{message}</Text>
              </Row>
              {item?.trap_name && (
                <Row>
                  <Text>
                    {item?.trap_name} - {item?.device_name}
                  </Text>
                </Row>
              )}
            </Col>
            <Col style={{ flexShrink: 0 }}>
              <Row>
                <Text className="text-[14px]!">{dateString} </Text>
              </Row>
            </Col>
          </Row>
        }
        showIcon
        icon={
          item.type !== "maintenance" ? (
            <CheckCircleIcon className="w-6 h-6 text-[#16A34A]!" />
          ) : (
            <ExclamationTriangleIcon className="w-6 h-6 text-[#F97316]!" />
          )
        }
        className={item.type !== "maintenance" ? "alert-info" : "alert-warning"}
      />
    </div>
  );
};

export default AlertDialog;
